/**
 * Safely coerce anything thrown / returned by an API into a human-readable
 * string. Guarantees a string is returned so it can never render as
 * "[object Object]" in a toast, snackbar, helperText or error handler.
 *
 * Handles:
 *  - plain strings
 *  - Error instances / objects with a `.message`
 *  - RTK Query rejections, which carry the server payload under `.data`
 */
export function toErrorMessage(error: unknown, fallback = "Something went wrong"): string {
  if (typeof error === "string") return error;

  if (error && typeof error === "object") {
    const e = error as any;
    // RTK Query rejections expose the server response under `data`.
    if (typeof e.data?.message === "string" && e.data.message) return e.data.message;
    if (typeof e.message === "string" && e.message) return e.message;
  }

  return fallback;
}
